module.exports = __webpack_public_path__ + "img/right-v3.dd6ca915.svg";